export const appLocales = [
  { value: 'zh-CN', label: '简体中文', speech: 'zh-CN' },
  { value: 'zh-TW', label: '繁體中文', speech: 'zh-TW' },
  { value: 'en', label: 'English', speech: 'en-US' },
  { value: 'ja', label: '日本語', speech: 'ja-JP' },
  { value: 'ko', label: '한국어', speech: 'ko-KR' },
] as const

export type AppLocale = typeof appLocales[number]['value']

export function normalizeLocale(value: unknown): AppLocale {
  return appLocales.find(item => item.value === value)?.value ?? 'zh-CN'
}
